import React from 'react'
import PropTypes from 'prop-types'
import useStyles from './statusChange.styles'
import { Grid } from '@material-ui/core'

const ChangeValidationStep = ({ productName, currentStatus, newStatus, reason }) => {
  const classes = useStyles()

  return (
    <div className={classes.confirmationContainer}>
      <p>Usted esta a punto de realizar el siguiente cambio:</p>
      <br />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <p>
            <strong>Producto:</strong> <br />
            {productName}
          </p>
        </Grid>
        <Grid item xs={6}>
          <p>
            <strong>Estado actual:</strong> <br />
            {currentStatus}
          </p>
        </Grid>
        <Grid item xs={6}>
          <p>
            <strong>Nuevo estado:</strong> <br />
            {newStatus}
          </p>
        </Grid>
        <Grid item xs={12}>
          <p>
            <strong>Motivo:</strong> <br />
            {reason}
          </p>
        </Grid>
      </Grid>
      <br />
    </div>
  )
}

ChangeValidationStep.propTypes = {
  productName: PropTypes.string.isRequired,
  currentStatus: PropTypes.string.isRequired,
  newStatus: PropTypes.string.isRequired,
  reason: PropTypes.string.isRequired,
}

export default ChangeValidationStep
